/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import { Chip as MuiChip, ChipProps as MuiChipProps } from "@mui/material";
import { mergeSx } from "@/src/utils/mergeSx.ts";
import { chipLegalbirdStyle } from "./chipLegalbirdStyle.ts";
import Typography from "@mui/material/Typography";

export type ChipLegalbirdProps = { light?: boolean } & MuiChipProps;

export default function ChipLegalbird({ light, sx, label, ...muiChipProps }: ChipLegalbirdProps) {
  return <MuiChip {...muiChipProps} sx={mergeSx(light && chipLegalbirdStyle.light, sx)} label={<Typography variant={"body1"}>{label}</Typography>} />;
}
